import {
  InterestsCalculatorVariant,
  TariffPaymentMethodSettingValue,
  TuitionPaymentType,
} from '../../../../types/tariffTypes';
import { formatToOnlyPositiveScaledIntegers } from '../../../../utils/currency';
import { FinantialConfig } from '../interfaces/finantial-config.interface';

export const DEFAULT_VALUES: FinantialConfig = {
  hasInterests: true,
  hasTariffDownPayment: true,
  hasTuition: false,
  chargeOnlineTuition: false,
  forceFirstInstallmentOnTuitionFree: false,
  hasPaymentMethod: false,
  interestRate: formatToOnlyPositiveScaledIntegers(`${1.5 * 100}`),
  maxTariffDownPaymentRate: formatToOnlyPositiveScaledIntegers(`${0 * 100}`),
  maxInstallments: 1,
  noInterestsInstallments: 1,
  interestCalculatorVariant: InterestsCalculatorVariant.ProrateInterest,
  payday: 5,
  tuitionPaymentType: TuitionPaymentType.TuitionProgram,
  hasEquivalenceCredit: false,
};

export const parseDefaultValuesFromFetch = (
  data: TariffPaymentMethodSettingValue,
): FinantialConfig => ({
  ...data,
  hasTariffDownPayment: !!data?.maxTariffDownPaymentRate,
  hasInterests: !!data?.interestRate,
  interestRate: formatToOnlyPositiveScaledIntegers(
    `${Number(data?.interestRate ?? 0) * 10000 ?? '0,00'}`,
  ),
  maxTariffDownPaymentRate: formatToOnlyPositiveScaledIntegers(
    `${Number(data?.maxTariffDownPaymentRate ?? 0) * 10000 ?? '0,00'}`,
  ),
  payday: data?.payday !== undefined ? data?.payday : DEFAULT_VALUES.payday,
  tuitionPaymentType:
    data?.tuitionPaymentType !== undefined
      ? data?.tuitionPaymentType
      : DEFAULT_VALUES.tuitionPaymentType,
  hasEquivalenceCredit: data?.hasEquivalenceCredit ?? false,
});

/**
 * Configuración General > Financieros - Matrícula no es dueña de los campos
 * de intereses, cuotas y abonos: esos viven en Portal Financiero >
 * Configuración (tab Cuotas), que ya hace su propio merge al guardar (ver
 * `InstallmentSettingsService`). El backend (`saveGeneralPaymentOptions`)
 * ignora estos campos aunque lleguen en el payload, así que ni siquiera los
 * enviamos: `hasInterests` y `hasTariffDownPayment` son además banderas de
 * sólo UI que no existen en el blob almacenado.
 */
export const parseDefaultValuesToFetch = (
  data: FinantialConfig,
): Partial<TariffPaymentMethodSettingValue> => {
  const {
    maxInstallments,
    interestRate,
    noInterestsInstallments,
    interestCalculatorVariant,
    quotaRoundingMethod,
    maxTariffDownPaymentRate,
    hasInterests,
    hasTariffDownPayment,
    ...owned
  } = data;

  return owned;
};
